import { useEffect, useState } from "react";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const EvaluationOfAdvisor_Review = ({index, advisor, evaluation}) => {

    function displayTerm(term) {
        if (term === -1) return "Now";
        let s = term%100 === 1 ? "Spring " : term%100 === 9 ? "Fall " : "";
        let y = String(Math.floor(term/100));
        if(!s || y === "0")
            return "???";
        return s+y;
    }

    if(!!evaluation || Object.keys(evaluation) > 0)
    return (
        <fieldset>
            <legend>
                Evaluation of {advisor.first} {advisor.last} ({displayTerm(advisor.start)} - {displayTerm(advisor.end)})
            </legend>
            <ol>
                <li> {/* Meeting Frequency */}
                    <p htmlFor={`eoa.${index}.meeting_frequency`}>How often do you meet with your advisor?</p>
                    <ReactQuill
                        theme="snow"
                        defaultValue={evaluation.meeting_frequency}
                        onChange={() => {}}
                        modules={{toolbar: false}}
                        readOnly={true}
                    />
                </li>
                <li> {/* Timely Feedback */}
                    <p>Do you feel like your advisor provides timely and constructive feedback?</p>
                    <div className="ea-options-div" style={{display:"flex", flexWrap:"wrap"}}>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.timely_feedback-Always`}
                                name={`eoa.${index}.timely_feedback_value`}
                                value={4}
                                checked={evaluation.timely_feedback_value === 4}
                                onChange={() => {}}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.timely_feedback-Always`}>Always</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.timely_feedback-Often`}
                                name={`eoa.${index}.timely_feedback_value`}
                                value={3}
                                checked={evaluation.timely_feedback_value === 3}
                                onChange={() => {}}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.timely_feedback-Often`}>Often</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.timely_feedback-Sometimes`}
                                name={`eoa.${index}.timely_feedback_value`}
                                value={2}
                                checked={evaluation.timely_feedback_value === 2}
                                onChange={() => {}}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.timely_feedback-Sometimes`}>Sometimes</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.timely_feedback-Rarely`}
                                name={`eoa.${index}.timely_feedback_value`}
                                value={1}
                                checked={evaluation.timely_feedback_value === 1}
                                onChange={() => {}}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.timely_feedback-Rarely`}>Rarely</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.timely_feedback-Never`}
                                name={`eoa.${index}.timely_feedback_value`}
                                value={0}
                                checked={evaluation.timely_feedback_value === 0}
                                onChange={() => {}}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.timely_feedback-Never`}>Never</label>
                        </div>
                    </div>
                    <ReactQuill
                        theme="snow"
                        defaultValue={evaluation.timely_feedback_text}
                        onChange={() => {}}
                        modules={{toolbar: false}}
                        readOnly={true}
                        placeholder="No explanation provided."
                    />
                </li>
                <li> {/* Professional Development */}
                    <p>Does your advisor support your professional development (e.g., career planning, conference attendance)?</p>
                    <div className="ea-options-div" style={{display:"flex", flexWrap:"wrap"}}>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.professional_development-Yes`}
                                name={`eoa.${index}.professional_development_value`}
                                value={2}
                                checked={evaluation.professional_development_value === 2}
                                onChange={() => {}}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.professional_development-Yes`}>Yes</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.professional_development-Sometimes`}
                                name={`eoa.${index}.professional_development_value`}
                                value={1}
                                checked={evaluation.professional_development_value === 1}
                                onChange={() => {}}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.professional_development-Sometimes`}>Sometimes</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.professional_development-No`}
                                name={`eoa.${index}.professional_development_value`}
                                value={0}
                                checked={evaluation.professional_development_value === 0}
                                onChange={() => {}}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.professional_development-No`}>No</label>
                        </div>
                    </div>
                    <ReactQuill
                        theme="snow"
                        defaultValue={evaluation.professional_development_text}
                        onChange={() => {}}
                        modules={{toolbar: false}}
                        readOnly={true}
                        placeholder="No explanation provided."
                    />
                </li>
                <li> {/* Approachability */}
                    <p>Do you feel comfortable approaching your advisor for help when needed?</p>
                    <div className="ea-options-div" style={{display:"flex", flexWrap:"wrap"}}>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.approachability-Yes`}
                                name={`eoa.${index}.approachability_value`}
                                value={2}
                                checked={evaluation.approachability_value === 2}
                                onChange={() => {}}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.approachability-Yes`}>Yes</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.approachability-Sometimes`}
                                name={`eoa.${index}.approachability_value`}
                                value={1}
                                checked={evaluation.approachability_value === 1}
                                onChange={() => {}}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.approachability-Sometimes`}>Sometimes</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.approachability-No`}
                                name={`eoa.${index}.approachability_value`}
                                value={0}
                                checked={evaluation.approachability_value === 0}
                                onChange={() => {}}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.approachability-No`}>No</label>
                        </div>
                    </div>
                    <ReactQuill
                        theme="snow"
                        defaultValue={evaluation.approachability_text}
                        onChange={() => {}}
                        modules={{toolbar: false}}
                        readOnly={true}
                        placeholder="No explanation provided."
                    />
                </li>
                <li> {/* Expectations and Goals */}
                    <p>Has your advisor helped you set clear expectations and goals for your research?</p>
                    <div className="ea-options-div" style={{display:"flex", flexWrap:"wrap"}}>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.expectations_and_goals-Yes`}
                                name={`eoa.${index}.expectations_and_goals_value`}
                                value={2}
                                checked={evaluation.expectations_and_goals_value === 2}
                                onChange={() => {}}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.expectations_and_goals-Yes`}>Yes</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.expectations_and_goals-Sometimes`}
                                name={`eoa.${index}.expectations_and_goals_value`}
                                value={1}
                                checked={evaluation.expectations_and_goals_value === 1}
                                onChange={() => {}}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.expectations_and_goals-Sometimes`}>Sometimes</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.expectations_and_goals-No`}
                                name={`eoa.${index}.expectations_and_goals_value`}
                                value={0}
                                checked={evaluation.expectations_and_goals_value === 0}
                                onChange={() => {}}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.expectations_and_goals-No`}>No</label>
                        </div>
                    </div>
                    <ReactQuill
                        theme="snow"
                        defaultValue={evaluation.expectations_and_goals_text}
                        onChange={() => {}}
                        modules={{toolbar: false}}
                        readOnly={true}
                        placeholder="No explanation provided."
                    />
                </li>
                <li> {/* Overall Satisfaction */}
                    <p>Overall, how satisfied are you with your advising relationship?</p>
                    <div className="ea-options-div" style={{display:"flex", flexWrap:"wrap"}}>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.overall_satisfaction-Very_Satisfied`}
                                name={`eoa.${index}.overall_satisfaction_value`}
                                value={4}
                                checked={evaluation.overall_satisfaction_value === 4}
                                onChange={() => {}}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.overall_satisfaction-Very_Satisfied`}>Very Satisfied</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.overall_satisfaction-Satisfied`}
                                name={`eoa.${index}.overall_satisfaction_value`}
                                value={3}
                                checked={evaluation.overall_satisfaction_value === 3}
                                onChange={() => {}}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.overall_satisfaction-Satisfied`}>Satisfied</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.overall_satisfaction-Neutral`}
                                name={`eoa.${index}.overall_satisfaction_value`}
                                value={2}
                                checked={evaluation.overall_satisfaction_value === 2}
                                onChange={() => {}}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.overall_satisfaction-Neutral`}>Neutral</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.overall_satisfaction-Dissatisfied`}
                                name={`eoa.${index}.overall_satisfaction_value`}
                                value={1}
                                checked={evaluation.overall_satisfaction_value === 1}
                                onChange={() => {}}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.overall_satisfaction-Dissatisfied`}>Dissatisfied</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.overall_satisfaction-Very_Dissatisfied`}
                                name={`eoa.${index}.overall_satisfaction_value`}
                                value={0}
                                checked={evaluation.overall_satisfaction_value === 0}
                                onChange={() => {}}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.overall_satisfaction-Very_Dissatisfied`}>Very Dissatisfied</label>
                        </div>
                    </div>
                    <ReactQuill
                        theme="snow"
                        defaultValue={evaluation.overall_satisfaction_text}
                        onChange={() => {}}
                        modules={{toolbar: false}}
                        readOnly={true}
                        placeholder="No explanation provided."
                    />
                </li>
                <li>
                    <p htmlFor={`eoa.${index}.additional_info`}>
                        Please share any additional information about your advising relationship or experience that you would like the Graduate Program Office to know:
                    </p>
                    <ReactQuill
                        theme="snow"
                        defaultValue={evaluation.additional_info}
                        onChange={() => {}}
                        modules={{toolbar: false}}
                        readOnly={true}
                        placeholder="No explanation provided."
                    />
                </li>
                <li>
                    <p htmlFor={`eoa.${index}.follow_up`}>
                        Would you like someone from the Graduate Program Office to follow up with you directly?
                    </p>
                    <div className="ea-options-div" style={{display:"flex", flexWrap:"wrap"}}>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.follow_up-Yes`}
                                name={`eoa.${index}.follow_up`}
                                value={1}
                                checked={evaluation.follow_up === 1}
                                onChange={() => {}}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.follow_up-Yes`}>Yes</label>
                        </div>
                        <div className="ea-radios">
                            <input
                                type="radio"
                                id={`eoa.${index}.follow_up-No`}
                                name={`eoa.${index}.follow_up`}
                                value={0}
                                checked={evaluation.follow_up === 0}
                                onChange={() => {}}
                            />
                            <label className="form-radio-options" htmlFor={`eoa.${index}.follow_up-No`}>No</label>
                        </div>
                    </div>
                </li>
            </ol>
        </fieldset>
    );
    else return <></>
}

export default EvaluationOfAdvisor_Review;